import { useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';

export default function useAutoRefresh(actionCreators, intervalMs = 30000) {
  const dispatch    = useDispatch();
  const actionsRef  = useRef(Array.isArray(actionCreators) ? actionCreators : [actionCreators]);

  const refresh = useCallback(() => {
    actionsRef.current.forEach(ac => dispatch(ac()));
  }, [dispatch]);

  useEffect(() => {
    const timer = setInterval(refresh, intervalMs);
    return () => clearInterval(timer);
  }, [refresh, intervalMs]);
}
